import { DrawerSection } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';
import BulletList from './BulletList.jsx';
import { DetailField } from '../shared/index.js';

/**
 * What the agent prepared for a human takeover — key facts, recommendations,
 * linked CRM / knowledge contract rows, and an agent summary callout (EVT-021).
 */
function HandoffPacketBlock({ packet, agentSummary }) {
  const { t } = useTranslation('work-queues-app');
  if (!packet && !agentSummary) return null;

  const keyFacts = packet?.keyFacts?.length ? packet.keyFacts : packet?.findings;
  const summary = agentSummary ?? packet?.agentSummary ?? null;
  const recordRows = [
    { label: t('handoff.crmRecord'), value: packet?.crmRecord },
    { label: t('handoff.knowledgeContract'), value: packet?.knowledgeContract },
  ].filter((row) => row.value);
  const hasLegacyRecords = !recordRows.length && packet?.linkedRecords?.length;
  const hasContent =
    keyFacts?.length ||
    packet?.recommendations?.length ||
    recordRows.length ||
    hasLegacyRecords ||
    packet?.nextAction ||
    summary;

  if (!hasContent) return null;

  return (
    <DrawerSection title={t('handoff.whatAgentPrepared')}>
      <div className="flex flex-col gap-4">
        <BulletList title={t('handoff.keyFacts')} items={keyFacts} />
        <BulletList title={t('handoff.recommendations')} items={packet?.recommendations} />

        {recordRows.length > 0 ? (
          <dl className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {recordRows.map((row) => (
              <DetailField key={row.label} label={row.label} value={row.value} />
            ))}
          </dl>
        ) : null}

        {hasLegacyRecords ? (
          <dl>
            <DetailField
              label={t('handoff.linkedRecords')}
              value={packet.linkedRecords.join(' · ')}
            />
          </dl>
        ) : null}

        {packet?.nextAction ? (
          <div>
            <p className="text-[11px] uppercase tracking-wide text-content-faint">
              {t('handoff.nextAction')}
            </p>
            <p className="mt-1 text-sm font-medium text-content">{packet.nextAction}</p>
          </div>
        ) : null}

        {summary ? (
          <div className="rounded-lg border border-edge bg-surface-muted px-4 py-3 text-sm leading-relaxed text-content-secondary">
            {summary}
          </div>
        ) : null}
      </div>
    </DrawerSection>
  );
}

export default HandoffPacketBlock;
